(() => {

    // Block Name
    const blockName = 'posts-listing';

    // Variables
    let method = 'front';
    if (document.querySelector('body') == null || document.querySelector('body').classList.contains('wp-admin')) {
        method = 'wp-admin';
    }
    // -- end

    // Custom methods

    // -- end

    // Init blocks
    const initializeBlock = (block) => {
        if (block[0] !== undefined) block = block[0].querySelector(`.block-${blockName}`);
        if (block === false || block === null) return;

        var $ = jQuery.noConflict();

        $('.js-filter-post--all').on('click', function () {
            $(this).closest('section').find('[data-active-trigger]').removeClass('active');
            $(this).addClass('active');
            $(this).closest('section').find('[data-active-target]').addClass('active');
        });

        $('.c-filter-post__pill').on('click', function () {
            let pageheader = $('.page-header').outerHeight();
            let sectionOffest;
            if ($(window).outerWidth() >= 992) {
                sectionOffest = $(this).closest('.block-posts-listing').offset().top;
            } else {
                sectionOffest = $(this).closest('.block-posts-listing__filter').offset().top;
            }

            $('html, body').animate({
                scrollTop: sectionOffest - pageheader
            }, 500);
        });

        $(document).ready(function () {
            filterSpacer();
        });
        $(window).on('resize', function () {
            filterSpacer();
        });

        function filterSpacer() {
            let pageheader = $('.page-header').outerHeight();
            $('.block-posts-listing__filter').css('top', pageheader);
        }
    };

    // Get all blocks
    const getBlocks = () => {
        let blocks = document.querySelectorAll(`.block-${blockName}`);
        if (blocks.length > 0) {
            blocks.forEach((block) => {
                initializeBlock(block);
            });
        }
    };

    // Frontend
    document.addEventListener("DOMContentLoaded", getBlocks);

    // Acf Init
    window.addEventListener('load', (event) => {
        if (window.acf) {
            getBlocks();

            // Add update block action for ACF
            window.acf.addAction(`render_block_preview/type=${blockName}`, initializeBlock);
        }
    });
})();
